<template>
  <div class="cyq-scan">
    <div class="content-box">
      <img class="banner-img" src="/static/images/cyq/banner.png" alt="banner">
      <div class="tip-text">点击下方按钮扫码查询</div>
      <div class="scan-btn" @click="handleScanClick">
        <img class="scan-icon" src="/static/images/cyq/scan.png" alt="scan">
      </div>
      <div class="manual-tip">手动输入查询码</div>
      <div class="input-box">
        <input class="code-input" type="text" placeholder="请输入查询码" v-model="antiCode">
        <div class="query-btn" @click="queryData">查询</div>
      </div>
    </div>
    <img class="bg-img" src="/static/images/cyq/bg.png" alt="bg">
  </div>
</template>

<script>
import { getJSSDK, queryAnti } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'CyqScan',
  data() {
    return {
      appId: process.env.ENV_NUM === '1' ? 'wxb576b8e7ccb1ad66' : 'wxbc22565b3e7a59fd',
      eno: process.env.ENV_NUM === '1' ? '138548738944' : '138495952793',
      antiCode: ''
    }
  },
  mounted() {
    this.getWxJs()
  },
  methods: {
    async queryData() {
      if (!this.antiCode.trim()) {
        alert('请输入查询码')
        return
      }
      if (!/^\d{16}$/.test(this.antiCode.trim())) {
        alert('请输入16位数字查询码')
        return
      }
      
      try {
        const res = await queryAnti(this.antiCode, this.eno)
        console.log('查询防伪信息结果:', res)
        
        if (res.data && res.data.code === 500) {
          alert('查询异常，请稍后再尝试扫码查询')
          return
        } else if (res.data && res.data.data && (res.data.data.replyCode == "300101" || res.data.data.replyCode == "300102")) {
          const deptId = res.data.data.deptId || ''
          this.$router.push({
            path: '/cyq/result',
            query: {
              c: this.antiCode,
              deptId: deptId
            }
          })
        } else {
          alert('此码不存在，谨防仿冒')
        }
      } catch (err) {
        console.error('查询防伪信息失败:', err)
        alert('查询失败，请重试')
      }
    },
    handleScanClick() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode"],
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http') && scanResult.includes('/?')) {
            let parts = scanResult.split('/?')
            scanQRCode = parts.length > 1 ? parts[1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          this.antiCode = scanQRCode
          this.queryData()
        }
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseimg',
            'predivimg',
            'uploadimg',
            'downloadimg',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificdiv',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  }
}
</script>

<style scoped>
.cyq-scan {
  width: 100vw;
  min-height: 100vh;
  background: white;
}

.content-box {
  width: 80vw;
  height: 90vh;
  margin: 8vh auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
}

.banner-img {
  width: 95%;
  height: auto;
}

.tip-text {
  margin-top: 3vh;
  font-size: 6vw;
  font-weight: bold;
  color: rgb(60, 60, 60);
}

.scan-btn {
  margin-top: 2vh;
  width: 120px;
  height: 120px;
  background: rgb(213, 213, 213);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scan-icon {
  width: 75%;
  height: 75%;
}

.manual-tip {
  margin-top: 5vh;
  font-size: 5.5vw;
  color: rgb(60, 60, 60);
}

.input-box {
  margin-top: 2vh;
  width: 90%;
  display: flex;
  border-radius: 8px;
  border: 1px solid rgb(139, 127, 128);
  overflow: hidden;
}

.code-input {
  width: 73%;
  height: 40px;
  border: none;
  padding: 0 0 0 4vw;
  font-size: 4vw;
  margin: 0;
}

.query-btn {
  width: 28%;
  height: 40px;
  background: rgb(27, 23, 179);
  color: white;
  font-size: 4vw;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid rgb(139, 127, 128);
}

.bg-img {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: auto;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Cyq/Scan.vue